import sanitize from 'sanitize-html';
import config from '../../../config';
import GaUserTypes from '../analytics/gaUserTypes';
import { serializeExperiments } from '../experiment';

export const dataLayer = (initialUserInfo = {}, initialUserProperties = {}) => {
  if (!config('gtmId')) return '';

  const initialDataLayer = (() => {
    if (Object.keys(initialUserInfo).length !== 0) {
      if (Object.keys(initialUserProperties).length !== 0)
        return JSON.stringify([initialUserProperties, initialUserInfo]);
      return JSON.stringify([initialUserInfo]);
    }

    return null;
  })();

  const scriptString = initialDataLayer
    ? `if(!window.google_tag_manager){dataLayer=(window.dataLayer||[]).concat(${sanitize(
        initialDataLayer
      )});(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${config(
        'gtmId'
      )}');}`
    : '';

  return scriptString;
};

export const buildGtmData = (userInfo, cookies) => {
  const { country, currency, locale, enrolments, federatedId } = userInfo;
  return country
    ? {
        country,
        currency,
        enrolments: serializeExperiments(enrolments) || 'none',
        language: locale,
        visitorType: GaUserTypes.getVisitorType(cookies, userInfo),
        federatedId
      }
    : {};
};

export default dataLayer;
